import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../providers/TacticHooksProvider";

export const useApiTokensQuery = () => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: ["useApiTokensQuery", apiClient.slug],

    queryFn: async () => {
      const res = await apiClient.apiTokens.list();
      return res.result;
    },

    enabled: !!apiClient.slug
  });
};
